import { render, staticRenderFns } from "./ShowEnvelopeInReviewByAnotherUserModal.vue?vue&type=template&id=145756ec&lang=pug"
import script from "./ShowEnvelopeInReviewByAnotherUserModal.vue?vue&type=script&lang=js"
export * from "./ShowEnvelopeInReviewByAnotherUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports